import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionBe from 'utils/mw/actionBe.util';

const beSwitchAllowanceYear = actionBe(
  'beSwitchAllowanceYear',
  withOptions(({ AT, ATAG, salonId, allowanceYear }) =>
    endpoint(H.patch, 'salon/:salonId/', {
      AT,
      name: ATAG,
      data: {
        salonId,
        allowance_year: allowanceYear,
      },
    }),
  ),
);

// noinspection JSUnusedGlobalSymbols
export default beSwitchAllowanceYear;
